"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_1 = require("../service");
var login = function (user) {
    return (0, service_1.getService)()
        .post('/login', user)
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.default = login;
